<template>
	<NuxtLayout
		name="detail"
		title="Trainingsschema en tijden"
		:breadcrumbs
		description="Bij Fit Hier train je op vaste momenten in de week in kleine groepen met persoonlijke begeleiding. Hieronder vind je het actuele lesrooster voor onze Small Group Trainingen: Functional Conditioning, Functional Strength en LifeFit."
	>
		<div class="flex flex-col gap-24 pt-24 pb-36">
			<div class="flex flex-col gap-12 bg-purple-900 pt-16 pb-16">
				<div class="container max-w-screen-md">
					<AtomTitle
						tag="h2"
						size="3xl"
						class="uppercase text-white"
					>
						Small Group Training lesrooster
					</AtomTitle>
				</div>
				<div class="px-12">
					<OrganismSchedule
						v-if="schedule"
						:schedule
						class=" rounded"
					/>
				</div>
			</div>
			<div class="container max-w-screen-md">
				<AtomCard class="p-12 flex flex-col gap-8">
					<div class="flex items-center gap-8">
						<AtomFontAwesome
							icon="fa-info-circle"
							class="size-12 text-purple-700"
						/>
						<AtomTitle
							tag="h2"
							size="xl"
						>
							Staat jouw ideale tijd er niet tussen?
						</AtomTitle>
					</div>
					<p>Bij Fit Hier maken we het trainingsrooster samen met onze leden. Zie je geen tijdstip dat voor jou werkt? Laat het ons weten! We denken graag met je mee en staan open voor aanpassingen. Samen zorgen we voor een rooster dat past bij jouw ritme én dat van de groep.</p>
				</AtomCard>
			</div>

			<CompositionActionButtonsSgt1 />
		</div>
	</NuxtLayout>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';

useSeoMeta({
	title: 'Trainingsschema Small Group Training in Uden | Fit Hier',
	ogTitle: 'Small Group Training Tijden bij Fit Hier in Uden',
	description: 'Bekijk het actuele trainingsschema en tijden voor Small Group Training in Uden. Flexibele planning, maximaal 6 deelnemers. Reserveer je plek bij Fit Hier!',
});

const breadcrumbs: BreadcrumbsType = [
	{
		text: 'Home',
		to: {
			title: 'Home',
			url: '/',
		},
	},
	{
		text: 'Small Group Training',
		to: {
			url: '/small-group-training',
			title: 'Small Group Training',
		},
	},
	{
		text: 'Trainingsschema & tijden',
		to: {
			url: '/small-group-training/trainingsschema-en-tijden',
			title: 'Trainingsschema & tijden',
		},
	},
];

const { data: schedule } = await useAsyncData('sgt-schedule', () => {
	return queryCollection('subscription_schedule').all();
});
</script>
